import { GET_ALLOTVEHICLE, GET_AVAILABLESUPPLIERS, GET_AVAILABLEVEHICLE, GET_CANCELCHARGES, GET_CANCELTRIP, GET_DISPATCHVEHICLE } from "resources/actionTypes";

const initialAllotState = {
    loading: false,
    error: null,
    allotedDetails: ""
  };

  const initialAvailableVehicleState = {
    loading: false,
    error: null,
  };

  const initialAvailableSuppliersState = {
    loading: false,
    error: null,
  };

  const initialCleareTripState = {
    loading: false,
    error: null,
  };

  const initialCancelTripChargesState = {
    loading: false,
    error: null,
    cancelCharges: ""
  };

export const allotVehicle = (state = initialAllotState, action) => {
  switch (action.type) {
    case GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        allotedDetails: action.allotedDetails
      };
    case GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export function getAvailableVehicle(state = initialAvailableVehicleState, action) {
  switch (action.type) {
    case GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        availableVehicle: action.availableVehicle,
      };
    case GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
      case GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_CLEAR:
      return {
        ...state,
        loading: false,
        availableVehicle: "",
      };
    default:
      return state;
  }
}

export function getAvailableSuppliers(state = initialAvailableSuppliersState, action) {

  switch (action.type) {
    case GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_SUCCESS:
      return {
        ...state,
        loading: false,
        availableSuppliers: action.availableSuppliers,
      };
    case GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
      case GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_CLEAR:
        return {
          ...state,
          loading: false,
          availableSuppliers: "",
        };
    default:
      return state;
  }
}


export const dispatchVehicle = (state = initialCleareTripState, action) => {
  switch (action.type) {
    case GET_DISPATCHVEHICLE.GET_DISPATCHVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DISPATCHVEHICLE.GET_DISPATCHVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_DISPATCHVEHICLE.GET_DISPATCHVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const cancelTrip = (state = initialCleareTripState, action) => {
  switch (action.type) {
    case GET_CANCELTRIP.GET_CANCELTRIP_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCELTRIP.GET_CANCELTRIP_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_CANCELTRIP.GET_CANCELTRIP_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getCancelTripCharges = (state = initialCancelTripChargesState, action) => {
  switch (action.type) {
    case GET_CANCELCHARGES.GET_CANCELCHARGES_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCELCHARGES.GET_CANCELCHARGES_SUCCESS:
      return {
        ...state,
        loading: false,
        cancelCharges: action.cancelCharges
      };
    case GET_CANCELCHARGES.GET_CANCELCHARGES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};